import React from 'react';
import { TRACKING } from 'common/constants/constants';
import projectProgressionCTA from 'images/projectProgressionCTA.jpg';
import CtaPage from 'components/CtaPage';
import { TEXT_POSITION } from 'components/CtaPage/constants';

const SECTION_TYPES = {
  FILTERS: 'FILTERS',
  PROGRESS_OVER_TIME: 'PROGRESS_OVER_TIME',
  DATA_TABLE: 'DATA_TABLE',
  INSIGHTS: 'INSIGHTS'
};

const TEXTS = {
  [SECTION_TYPES.FILTERS]:
    'Forecasting uses a ' +
    'highly flexible data ' +
    'segmentation system. ' +
    'Your team can identify ' +
    'projects by name, or by any ' +
    'combination of team, ' +
    'board, label, tag, or ' +
    'previously defined project.',
  [SECTION_TYPES.PROGRESS_OVER_TIME]:
    'Every stakeholder can ' +
    'quickly view the health, ' +
    'progress and estimated ' +
    'delivery times of their most ' +
    'important initiatives using a ' +
    'real-time burn up chart.',
  [SECTION_TYPES.INSIGHTS]: (
    <>
      Predictable project delivery requires the ability to identify and address
      risks before they delay timelines.
      <br />
      <br />
      Project insights turns status updates into meaningful conversations with
      trackable outcomes.
    </>
  ),
  [SECTION_TYPES.DATA_TABLE]:
    'Dive deeper into your data ' +
    'with visibility into the ' +
    'initiatives, epics and issues ' +
    'that make up your project. ' +
    'Delivery status and work ' +
    'type filters provide owners ' +
    'with real-time status updates.'
};

const SECTIONS = [
  {
    sectionType: SECTION_TYPES.FILTERS,
    buttonPosition: {
      left: '35rem',
      top: '2rem'
    },
    coverProps: {
      height: '6rem',
      width: '100%',
      position: { top: 0 }
    },
    textPosition: {
      left: TEXT_POSITION,
      top: '2rem'
    },
    isTextLeft: true,
    arrowLength: true
  },
  {
    sectionType: SECTION_TYPES.PROGRESS_OVER_TIME,
    buttonPosition: {
      left: '16rem',
      top: '15rem'
    },
    coverProps: {
      height: '24rem',
      width: '70%',
      position: { left: 0, top: '6rem' }
    },
    textPosition: {
      left: TEXT_POSITION,
      top: '10rem'
    },
    isTextLeft: true,
    arrowLength: true
  },
  {
    sectionType: SECTION_TYPES.INSIGHTS,
    buttonPosition: {
      right: '12rem',
      top: '7rem'
    },
    coverProps: {
      height: '24rem',
      width: '30%',
      position: { top: '6rem', right: '0rem' }
    },
    textPosition: {
      right: TEXT_POSITION,
      top: '10rem'
    },
    arrowLength: true
  },
  {
    sectionType: SECTION_TYPES.DATA_TABLE,
    buttonPosition: {
      left: '28rem',
      bottom: '13rem'
    },
    coverProps: {
      height: '20rem',
      width: '100%',
      position: { bottom: 0, top: '30rem' }
    },
    textPosition: {
      right: TEXT_POSITION,
      bottom: '2.5rem'
    },
    arrowLength: true
  }
];

const ProjectProgressionCta = () => (
  <CtaPage
    textsMap={TEXTS}
    page={TRACKING.PAGES.PROJECT_PROGRESSION}
    pageTab={TRACKING.PAGE_TABS.PROJECT_PROGRESSION_CTA}
    buttonLineProps={{
      textWidth: '70%',
      leftText:
        'Unlock forecasting to see the current status of the project!'.toUpperCase(),
      buttonText: 'BOOK A DEMO NOW'
    }}
    backgroundImage={projectProgressionCTA}
    sections={SECTIONS}
  />
);

export default ProjectProgressionCta;
